import React from 'react';

const ConfirmationModal = ({ isOpen, onConfirm, onCancel }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-10">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center w-1/3">
                <h2 className="text-xl font-semibold mb-4">Are you sure you want to log out?</h2>
                <div className="flex justify-around">
                    <button 
                        onClick={onConfirm} 
                        className="bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600 transition"
                    >
                        Yes
                    </button>
                    <button 
                        onClick={onCancel} 
                        className="bg-red-500 text-white px-6 py-2 rounded-md hover:bg-red-600 transition"
                    >
                        No
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
